export class InvalidError extends Error {}